export interface RetryConfig {
  maxRetries: number;
  errorLimitBeforeReload: number;
  reloadDelay: number;
  baseRetryDelay: number;
  importFunction?: (path: string) => Promise<any>;
}

export const DEFAULT_RETRY_CONFIG: RetryConfig = {
  maxRetries: 5,
  errorLimitBeforeReload: 1,
  reloadDelay: 50,
  baseRetryDelay: 1000,
  importFunction: (path: string) => import(/* @vite-ignore */ path),
} as const;